// extracted by mini-css-extract-plugin
module.exports = {"minFontSize":"12px","middleFontSize":"14px","maxFontSize":"30px","subTitleFontSize":"20px"};